<template>
<div>
    <v-text-field
      v-model='rawPhoneNumber'
      type='tel'
      :append-icon='iconAppend'
      :hint='hintText'
      persistent-hint
      class="input-group--focused xl"
      label='phone number' >

      <v-btn outlined
        slot='prepend'
        class='mt-1 pa-1'
        @click='countryCodePicker=true'
        style='min-width:20px !important;' >
        +{{selectedCountry.code}}
        <!-- <v-icon x-small >mdi-chevron-down</v-icon> -->
      </v-btn>
    </v-text-field>
    <pre v-if='verbose'>
      inferred: {{inferredCountryCode}}
      selected: {{isocode}}
      valid: {{isValidNumber}}
      raw: {{rawPhoneNumber}}
      parsed: {{parsedNumber}}
      formatted: {{formattedNumber}}
      type: {{numberType}}
    </pre>

    <v-dialog
      v-model='countryCodePicker'
      style='width:300px;' >
    <v-list dense single-line
      style='height:500px;overflow:scroll;' >
      <v-toolbar class='elevation-0' color="white" dense >
          <v-text-field v-model='searchString' clearable label='search' prepend-icon="mdi-magnify" hide-details single-line></v-text-field>
      </v-toolbar>
      <v-subheader v-if='filteredShortList.length > 0' class='overline' >Quickpick</v-subheader>
      <v-list-item
        v-for='(country, index) in filteredShortList'
        @click='setCountry(country)'
        :key='index' >
        <v-list-item-action>+{{country.code}}</v-list-item-action>
        <v-list-item-content >
          <v-list-item-title v-text='country.name' />
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        v-for='country in filteredCountries'
        @click='setCountry(country)'
        :key='country.name' >
        <v-list-item-content >
          <v-list-item-title >
            (+{{country.code}}) {{ country.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-dialog>
</div>

</template>

<script>
import {
  // format,
  // isValidNumber,
  // parsePhoneNumber,
  // getExampleNumber,
  // parsePhoneNumberFromString
  AsYouType
} from 'libphonenumber-js'

export default {
  name: 'PhoneNumberInput',
  props: {
    value: {type: String},
    touch: {type: String},
    selectedCountryCode: {type: String, default: 'ZA'},
    verbose: { type: Boolean, default: false },
    shortList: {type: Array, default: () => { return [] }}
  },
  data () {
    return {
      rawPhoneNumber: '',
      countryCodePicker: false,
      isocode: 'ZA',
      searchString: null,
      countryCodes: [{'code': 93, 'name': 'Afghanistan', 'iso2': 'AF'}, {'code': 358, 'name': 'Aland Islands', 'iso2': 'AX'}, {'code': 355, 'name': 'Albania', 'iso2': 'AL'}, {'code': 213, 'name': 'Algeria', 'iso2': 'DZ'}, {'code': 1, 'name': 'American Samoa', 'iso2': 'AS'}, {'code': 376, 'name': 'Andorra', 'iso2': 'AD'}, {'code': 244, 'name': 'Angola', 'iso2': 'AO'}, {'code': 1, 'name': 'Anguilla', 'iso2': 'AI'}, {'code': null, 'name': 'Antarctica', 'iso2': 'AQ'}, {'code': 1, 'name': 'Antigua and Barbuda', 'iso2': 'AG'}, {'code': 54, 'name': 'Argentina', 'iso2': 'AR'}, {'code': 374, 'name': 'Armenia', 'iso2': 'AM'}, {'code': 297, 'name': 'Aruba', 'iso2': 'AW'}, {'code': 61, 'name': 'Australia', 'iso2': 'AU'}, {'code': 43, 'name': 'Austria', 'iso2': 'AT'}, {'code': 994, 'name': 'Azerbaijan', 'iso2': 'AZ'}, {'code': 1, 'name': 'Bahamas', 'iso2': 'BS'}, {'code': 973, 'name': 'Bahrain', 'iso2': 'BH'}, {'code': 880, 'name': 'Bangladesh', 'iso2': 'BD'}, {'code': 1, 'name': 'Barbados', 'iso2': 'BB'}, {'code': 375, 'name': 'Belarus', 'iso2': 'BY'}, {'code': 32, 'name': 'Belgium', 'iso2': 'BE'}, {'code': 501, 'name': 'Belize', 'iso2': 'BZ'}, {'code': 229, 'name': 'Benin', 'iso2': 'BJ'}, {'code': 1, 'name': 'Bermuda', 'iso2': 'BM'}, {'code': 975, 'name': 'Bhutan', 'iso2': 'BT'}, {'code': 591, 'name': 'Bolivia,  Plurinational State of', 'iso2': 'BO'}, {'code': 599, 'name': 'Bonaire,  Sint Eustatius and Saba', 'iso2': 'BQ'}, {'code': 387, 'name': 'Bosnia and Herzegovina', 'iso2': 'BA'}, {'code': 267, 'name': 'Botswana', 'iso2': 'BW'}, {'code': null, 'name': 'Bouvet Island', 'iso2': 'BV'}, {'code': 55, 'name': 'Brazil', 'iso2': 'BR'}, {'code': 246, 'name': 'British Indian Ocean Territory', 'iso2': 'IO'}, {'code': 673, 'name': 'Brunei Darussalam', 'iso2': 'BN'}, {'code': 359, 'name': 'Bulgaria', 'iso2': 'BG'}, {'code': 226, 'name': 'Burkina Faso', 'iso2': 'BF'}, {'code': 257, 'name': 'Burundi', 'iso2': 'BI'}, {'code': 238, 'name': 'Cabo Verde', 'iso2': 'CV'}, {'code': 855, 'name': 'Cambodia', 'iso2': 'KH'}, {'code': 237, 'name': 'Cameroon', 'iso2': 'CM'}, {'code': 1, 'name': 'Canada', 'iso2': 'CA'}, {'code': 1, 'name': 'Cayman Islands', 'iso2': 'KY'}, {'code': 236, 'name': 'Central African Republic', 'iso2': 'CF'}, {'code': 235, 'name': 'Chad', 'iso2': 'TD'}, {'code': 56, 'name': 'Chile', 'iso2': 'CL'}, {'code': 86, 'name': 'China', 'iso2': 'CN'}, {'code': 61, 'name': 'Christmas Island', 'iso2': 'CX'}, {'code': 61, 'name': 'Cocos (Keeling) Islands', 'iso2': 'CC'}, {'code': 57, 'name': 'Colombia', 'iso2': 'CO'}, {'code': 269, 'name': 'Comoros', 'iso2': 'KM'}, {'code': 242, 'name': 'Congo', 'iso2': 'CG'}, {'code': 243, 'name': 'Congo,  The Democratic Republic of the', 'iso2': 'CD'}, {'code': 682, 'name': 'Cook Islands', 'iso2': 'CK'}, {'code': 506, 'name': 'Costa Rica', 'iso2': 'CR'}, {'code': 385, 'name': 'Croatia', 'iso2': 'HR'}, {'code': 53, 'name': 'Cuba', 'iso2': 'CU'}, {'code': 599, 'name': 'Curaçao', 'iso2': 'CW'}, {'code': 357, 'name': 'Cyprus', 'iso2': 'CY'}, {'code': 420, 'name': 'Czechia', 'iso2': 'CZ'}, {'code': 225, 'name': 'Côte dIvoire', 'iso2': 'CI'}, {'code': 45, 'name': 'Denmark', 'iso2': 'DK'}, {'code': 253, 'name': 'Djibouti', 'iso2': 'DJ'}, {'code': 1, 'name': 'Dominica', 'iso2': 'DM'}, {'code': 1, 'name': 'Dominican Republic', 'iso2': 'DO'}, {'code': 593, 'name': 'Ecuador', 'iso2': 'EC'}, {'code': 20, 'name': 'Egypt', 'iso2': 'EG'}, {'code': 503, 'name': 'El Salvador', 'iso2': 'SV'}, {'code': 240, 'name': 'Equatorial Guinea', 'iso2': 'GQ'}, {'code': 291, 'name': 'Eritrea', 'iso2': 'ER'}, {'code': 372, 'name': 'Estonia', 'iso2': 'EE'}, {'code': 251, 'name': 'Ethiopia', 'iso2': 'ET'}, {'code': 500, 'name': 'Falkland Islands (Malvinas)', 'iso2': 'FK'}, {'code': 298, 'name': 'Faroe Islands', 'iso2': 'FO'}, {'code': 679, 'name': 'Fiji', 'iso2': 'FJ'}, {'code': 358, 'name': 'Finland', 'iso2': 'FI'}, {'code': 33, 'name': 'France', 'iso2': 'FR'}, {'code': 594, 'name': 'French Guiana', 'iso2': 'GF'}, {'code': 689, 'name': 'French Polynesia', 'iso2': 'PF'}, {'code': null, 'name': 'French Southern Territories', 'iso2': 'TF'}, {'code': 241, 'name': 'Gabon', 'iso2': 'GA'}, {'code': 220, 'name': 'Gambia', 'iso2': 'GM'}, {'code': 995, 'name': 'Georgia', 'iso2': 'GE'}, {'code': 49, 'name': 'Germany', 'iso2': 'DE'}, {'code': 233, 'name': 'Ghana', 'iso2': 'GH'}, {'code': 350, 'name': 'Gibraltar', 'iso2': 'GI'}, {'code': 30, 'name': 'Greece', 'iso2': 'GR'}, {'code': 299, 'name': 'Greenland', 'iso2': 'GL'}, {'code': 1, 'name': 'Grenada', 'iso2': 'GD'}, {'code': 590, 'name': 'Guadeloupe', 'iso2': 'GP'}, {'code': 1, 'name': 'Guam', 'iso2': 'GU'}, {'code': 502, 'name': 'Guatemala', 'iso2': 'GT'}, {'code': 44, 'name': 'Guernsey', 'iso2': 'GG'}, {'code': 224, 'name': 'Guinea', 'iso2': 'GN'}, {'code': 245, 'name': 'Guinea-Bissau', 'iso2': 'GW'}, {'code': 592, 'name': 'Guyana', 'iso2': 'GY'}, {'code': 509, 'name': 'Haiti', 'iso2': 'HT'}, {'code': null, 'name': 'Heard Island and McDonald Islands', 'iso2': 'HM'}, {'code': 39, 'name': 'Holy See (Vatican City State)', 'iso2': 'VA'}, {'code': 504, 'name': 'Honduras', 'iso2': 'HN'}, {'code': 852, 'name': 'Hong Kong', 'iso2': 'HK'}, {'code': 36, 'name': 'Hungary', 'iso2': 'HU'}, {'code': 354, 'name': 'Iceland', 'iso2': 'IS'}, {'code': 91, 'name': 'India', 'iso2': 'IN'}, {'code': 62, 'name': 'Indonesia', 'iso2': 'ID'}, {'code': 98, 'name': 'Iran,  Islamic Republic of', 'iso2': 'IR'}, {'code': 964, 'name': 'Iraq', 'iso2': 'IQ'}, {'code': 353, 'name': 'Ireland', 'iso2': 'IE'}, {'code': 44, 'name': 'Isle of Man', 'iso2': 'IM'}, {'code': 972, 'name': 'Israel', 'iso2': 'IL'}, {'code': 39, 'name': 'Italy', 'iso2': 'IT'}, {'code': 1, 'name': 'Jamaica', 'iso2': 'JM'}, {'code': 81, 'name': 'Japan', 'iso2': 'JP'}, {'code': 44, 'name': 'Jersey', 'iso2': 'JE'}, {'code': 962, 'name': 'Jordan', 'iso2': 'JO'}, {'code': 7, 'name': 'Kazakhstan', 'iso2': 'KZ'}, {'code': 254, 'name': 'Kenya', 'iso2': 'KE'}, {'code': 686, 'name': 'Kiribati', 'iso2': 'KI'}, {'code': 850, 'name': 'Democratic Peoples Republic of Korea', 'iso2': 'KP'}, {'code': 82, 'name': 'Republic of Korea', 'iso2': 'KR'}, {'code': 965, 'name': 'Kuwait', 'iso2': 'KW'}, {'code': 996, 'name': 'Kyrgyzstan', 'iso2': 'KG'}, {'code': 856, 'name': 'Lao Peoples Democratic Republic', 'iso2': 'LA'}, {'code': 371, 'name': 'Latvia', 'iso2': 'LV'}, {'code': 961, 'name': 'Lebanon', 'iso2': 'LB'}, {'code': 266, 'name': 'Lesotho', 'iso2': 'LS'}, {'code': 231, 'name': 'Liberia', 'iso2': 'LR'}, {'code': 218, 'name': 'Libya', 'iso2': 'LY'}, {'code': 423, 'name': 'Liechtenstein', 'iso2': 'LI'}, {'code': 370, 'name': 'Lithuania', 'iso2': 'LT'}, {'code': 352, 'name': 'Luxembourg', 'iso2': 'LU'}, {'code': 853, 'name': 'Macao', 'iso2': 'MO'}, {'code': 389, 'name': 'Macedonia Republic of', 'iso2': 'MK'}, {'code': 261, 'name': 'Madagascar', 'iso2': 'MG'}, {'code': 265, 'name': 'Malawi', 'iso2': 'MW'}, {'code': 60, 'name': 'Malaysia', 'iso2': 'MY'}, {'code': 960, 'name': 'Maldives', 'iso2': 'MV'}, {'code': 223, 'name': 'Mali', 'iso2': 'ML'}, {'code': 356, 'name': 'Malta', 'iso2': 'MT'}, {'code': 692, 'name': 'Marshall Islands', 'iso2': 'MH'}, {'code': 596, 'name': 'Martinique', 'iso2': 'MQ'}, {'code': 222, 'name': 'Mauritania', 'iso2': 'MR'}, {'code': 230, 'name': 'Mauritius', 'iso2': 'MU'}, {'code': 262, 'name': 'Mayotte', 'iso2': 'YT'}, {'code': 52, 'name': 'Mexico', 'iso2': 'MX'}, {'code': 691, 'name': 'Micronesia', 'iso2': 'FM'}, {'code': 373, 'name': 'Moldova', 'iso2': 'MD'}, {'code': 377, 'name': 'Monaco', 'iso2': 'MC'}, {'code': 976, 'name': 'Mongolia', 'iso2': 'MN'}, {'code': 382, 'name': 'Montenegro', 'iso2': 'ME'}, {'code': 1, 'name': 'Montserrat', 'iso2': 'MS'}, {'code': 212, 'name': 'Morocco', 'iso2': 'MA'}, {'code': 258, 'name': 'Mozambique', 'iso2': 'MZ'}, {'code': 95, 'name': 'Myanmar', 'iso2': 'MM'}, {'code': 264, 'name': 'Namibia', 'iso2': 'NA'}, {'code': 674, 'name': 'Nauru', 'iso2': 'NR'}, {'code': 977, 'name': 'Nepal', 'iso2': 'NP'}, {'code': 31, 'name': 'Netherlands', 'iso2': 'NL'}, {'code': 687, 'name': 'New Caledonia', 'iso2': 'NC'}, {'code': 64, 'name': 'New Zealand', 'iso2': 'NZ'}, {'code': 505, 'name': 'Nicaragua', 'iso2': 'NI'}, {'code': 227, 'name': 'Niger', 'iso2': 'NE'}, {'code': 234, 'name': 'Nigeria', 'iso2': 'NG'}, {'code': 683, 'name': 'Niue', 'iso2': 'NU'}, {'code': 672, 'name': 'Norfolk Island', 'iso2': 'NF'}, {'code': 1, 'name': 'Northern Mariana Islands', 'iso2': 'MP'}, {'code': 47, 'name': 'Norway', 'iso2': 'NO'}, {'code': 968, 'name': 'Oman', 'iso2': 'OM'}, {'code': 92, 'name': 'Pakistan', 'iso2': 'PK'}, {'code': 680, 'name': 'Palau', 'iso2': 'PW'}, {'code': 970, 'name': 'Palestine', 'iso2': 'PS'}, {'code': 507, 'name': 'Panama', 'iso2': 'PA'}, {'code': 675, 'name': 'Papua New Guinea', 'iso2': 'PG'}, {'code': 595, 'name': 'Paraguay', 'iso2': 'PY'}, {'code': 51, 'name': 'Peru', 'iso2': 'PE'}, {'code': 63, 'name': 'Philippines', 'iso2': 'PH'}, {'code': null, 'name': 'Pitcairn', 'iso2': 'PN'}, {'code': 48, 'name': 'Poland', 'iso2': 'PL'}, {'code': 351, 'name': 'Portugal', 'iso2': 'PT'}, {'code': 1, 'name': 'Puerto Rico', 'iso2': 'PR'}, {'code': 974, 'name': 'Qatar', 'iso2': 'QA'}, {'code': 40, 'name': 'Romania', 'iso2': 'RO'}, {'code': 7, 'name': 'Russian Federation', 'iso2': 'RU'}, {'code': 250, 'name': 'Rwanda', 'iso2': 'RW'}, {'code': 262, 'name': 'Réunion', 'iso2': 'RE'}, {'code': 590, 'name': 'Saint Barthélemy', 'iso2': 'BL'}, {'code': 290, 'name': 'Saint Helena Ascension and Tristan da Cunha', 'iso2': 'SH'}, {'code': 1, 'name': 'Saint Kitts and Nevis', 'iso2': 'KN'}, {'code': 1, 'name': 'Saint Lucia', 'iso2': 'LC'}, {'code': 590, 'name': 'Saint Martin (French part)', 'iso2': 'MF'}, {'code': 508, 'name': 'Saint Pierre and Miquelon', 'iso2': 'PM'}, {'code': 1, 'name': 'Saint Vincent and the Grenadines', 'iso2': 'VC'}, {'code': 685, 'name': 'Samoa', 'iso2': 'WS'}, {'code': 378, 'name': 'San Marino', 'iso2': 'SM'}, {'code': 239, 'name': 'Sao Tome and Principe', 'iso2': 'ST'}, {'code': 966, 'name': 'Saudi Arabia', 'iso2': 'SA'}, {'code': 221, 'name': 'Senegal', 'iso2': 'SN'}, {'code': 381, 'name': 'Serbia', 'iso2': 'RS'}, {'code': 248, 'name': 'Seychelles', 'iso2': 'SC'}, {'code': 232, 'name': 'Sierra Leone', 'iso2': 'SL'}, {'code': 65, 'name': 'Singapore', 'iso2': 'SG'}, {'code': 1, 'name': 'Sint Maarten (Dutch part)', 'iso2': 'SX'}, {'code': 421, 'name': 'Slovakia', 'iso2': 'SK'}, {'code': 386, 'name': 'Slovenia', 'iso2': 'SI'}, {'code': 677, 'name': 'Solomon Islands', 'iso2': 'SB'}, {'code': 252, 'name': 'Somalia', 'iso2': 'SO'}, {'code': 27, 'name': 'South Africa', 'iso2': 'ZA'}, {'code': null, 'name': 'South Georgia and the South Sandwich Islands', 'iso2': 'GS'}, {'code': 211, 'name': 'South Sudan', 'iso2': 'SS'}, {'code': 34, 'name': 'Spain', 'iso2': 'ES'}, {'code': 94, 'name': 'Sri Lanka', 'iso2': 'LK'}, {'code': 249, 'name': 'Sudan', 'iso2': 'SD'}, {'code': 597, 'name': 'Suriname', 'iso2': 'SR'}, {'code': 47, 'name': 'Svalbard and Jan Mayen', 'iso2': 'SJ'}, {'code': 268, 'name': 'Swaziland', 'iso2': 'SZ'}, {'code': 46, 'name': 'Sweden', 'iso2': 'SE'}, {'code': 41, 'name': 'Switzerland', 'iso2': 'CH'}, {'code': 963, 'name': 'Syrian Arab Republic', 'iso2': 'SY'}, {'code': 886, 'name': 'Taiwan', 'iso2': 'TW'}, {'code': 992, 'name': 'Tajikistan', 'iso2': 'TJ'}, {'code': 255, 'name': 'Tanzania', 'iso2': 'TZ'}, {'code': 66, 'name': 'Thailand', 'iso2': 'TH'}, {'code': 670, 'name': 'Timor-Leste', 'iso2': 'TL'}, {'code': 228, 'name': 'Togo', 'iso2': 'TG'}, {'code': 690, 'name': 'Tokelau', 'iso2': 'TK'}, {'code': 676, 'name': 'Tonga', 'iso2': 'TO'}, {'code': 1, 'name': 'Trinidad and Tobago', 'iso2': 'TT'}, {'code': 216, 'name': 'Tunisia', 'iso2': 'TN'}, {'code': 90, 'name': 'Turkey', 'iso2': 'TR'}, {'code': 993, 'name': 'Turkmenistan', 'iso2': 'TM'}, {'code': 1, 'name': 'Turks and Caicos Islands', 'iso2': 'TC'}, {'code': 688, 'name': 'Tuvalu', 'iso2': 'TV'}, {'code': 256, 'name': 'Uganda', 'iso2': 'UG'}, {'code': 380, 'name': 'Ukraine', 'iso2': 'UA'}, {'code': 971, 'name': 'United Arab Emirates', 'iso2': 'AE'}, {'code': 44, 'name': 'United Kingdom', 'iso2': 'GB'}, {'code': 1, 'name': 'United States', 'iso2': 'US'}, {'code': null, 'name': 'United States Minor Outlying Islands', 'iso2': 'UM'}, {'code': 598, 'name': 'Uruguay', 'iso2': 'UY'}, {'code': 998, 'name': 'Uzbekistan', 'iso2': 'UZ'}, {'code': 678, 'name': 'Vanuatu', 'iso2': 'VU'}, {'code': 58, 'name': 'Venezuela', 'iso2': 'VE'}, {'code': 84, 'name': 'Viet Nam', 'iso2': 'VN'}, {'code': 1, 'name': 'British Virgin Islands', 'iso2': 'VG'}, {'code': 1, 'name': 'US Virgin Islands', 'iso2': 'VI'}, {'code': 681, 'name': 'Wallis and Futuna', 'iso2': 'WF'}, {'code': 212, 'name': 'Western Sahara', 'iso2': 'EH'}, {'code': 967, 'name': 'Yemen', 'iso2': 'YE'}, {'code': 260, 'name': 'Zambia', 'iso2': 'ZM'}, {'code': 263, 'name': 'Zimbabwe', 'iso2': 'ZW'}]
    }
  },
  methods: {
    emitNumber () {
      let numbers = this.typedNumber
      let number = this.parsedNumber
      let isValid = this.isValidNumber
      this.$emit('input', number)
      this.$emit('number', number)
      this.$emit('meta', numbers)
      this.$emit('valid', isValid)
    },
    setCountry (country) {
      this.isocode = country.iso2
      this.countryCodePicker = false
      this.emitNumber()
    }
  },
  computed: {
    selectedCountry () {
      return this.countryCodes.find((item) => {
        return this.isocode === item.iso2
      })
    },
    filteredCountries () {
      if (this.searchString === null || this.searchString.length < 1) {
        return this.countryCodes
      }
      return this.countryCodes.filter((item) => {
        if (!(item.code) || !(item.name)) {
          // console.log(JSON.stringify(item))
        } else {
          let search = this.searchString.toLowerCase()
          let codeMatch = item.code.toString().toLowerCase().indexOf(search) !== -1
          let nameMatch = item.name.toLowerCase().indexOf(search) !== -1
          return (codeMatch || nameMatch)
        }
      })
    },
    filteredShortList () {
      if (this.shortList.length === 0) { return [] }
      return this.filteredCountries.filter((item) => {
        return this.shortList.indexOf(item.iso2) !== -1
      })
    },
    isValidNumber () {
      if (this.typedNumber) {
        return this.typedNumber.isValid()
      }
      return false
    },
    parsedNumber () {
      if (this.typedNumber) {
        return this.typedNumber.number
      }
      return ''
    },
    formattedNumber () {
      if (this.typedNumber) {
        return this.typedNumber.formatInternational()
      }
      return ''
    },
    numberType () {
      if (this.typedNumber) {
        return this.typedNumber.getType()
      }
      return null
    },
    inferredCountryCode () {
      if (this.typedNumber) {
        return this.typedNumber.country
      }
      return null
    },
    iconAppend () {
      // this.typedNumber.international_plaintext.length === 12
      if (this.isValidNumber) {
        return 'mdi-check'
      }
      return 'mdi-close'
    },
    hintText () {
      if (!this.rawPhoneNumber) {
        return 'Please provide a valid phone number'
      }
      if (this.isValidNumber) {
        return '✓ Valid number for ' + this.selectedCountry.name + ': ' + this.formattedNumber
      } else {
        return 'Not a valid phone number. Are you sure you have the correct country code?'
      }
    },
    typedNumber () {
      if (this.rawPhoneNumber) {
        let ayt = new AsYouType(this.isocode)
        let inputIsInternational = this.rawPhoneNumber.startsWith('+')
        if (inputIsInternational) {
          ayt = new AsYouType()
        }
        ayt.input(this.rawPhoneNumber)
        let number = ayt.getNumber()
        return number
      }
      return ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          let ayt = new AsYouType(this.value)
          ayt.input(this.value)
          let number = ayt.getNumber()
          if (number && number.isValid()) {
            this.rawPhoneNumber = this.value
          }
        }
      }
    },
    isValidNumber () {
      this.$emit('valid', this.isValidNumber)
    },
    selectedCountryCode () {
      if (this.selectedCountryCode) {
        this.isocode = this.selectedCountryCode
        this.rawPhoneNumber = this.typedNumber
      }
    },
    inferredCountryCode: {
      immediate: true,
      handler () {
        let typedNumberContainsCountryCode = this
          .rawPhoneNumber
          .startsWith('+')

        if (
          typedNumberContainsCountryCode &&
          this.inferredCountryCode &&
          this.inferredCountryCode !== this.isocode) {
          this.isocode = this.inferredCountryCode
          // console.log(this.isocode, this.inferredCountryCode)
        }
      }
    },
    touch () {
      // this.rawPhoneNumber = this.value
      this.rawPhoneNumber = this.touch
      this.emitNumber()
    },
    rawPhoneNumber () {
      this.emitNumber()
    }
  }
}
</script>

<style>

</style>
